import { useEstimationUserAssignmentQueryActions } from '@/api/hooks/estimationUserAssignmentQueryActions';
import type { ApiEstimationPermission } from '@/api/schema/data-contracts';

export const useHasEstimationPermission = (
  estimationId: string | undefined,
  permission: ApiEstimationPermission,
) => {
  const { useGetEstimationPermissions } = useEstimationUserAssignmentQueryActions();
  const { data } = useGetEstimationPermissions(estimationId) as {
    data: ApiEstimationPermission[] | undefined;
    isLoading: boolean;
  };

  if (!data) {
    return undefined;
  }

  return data.includes(permission);
};
